// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"FuncionDetalle_spinnerContainer__sbtuq"};